import React from 'react';

import { InputAdornment } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

import { Button, TextField } from '../../../../components/atoms';
import { Tick } from '../../../../components/icons';
import * as Api from '../../../../weborder/Api';
import { CurrencySymbols } from '../../../../weborder/BasketControl';

const useStyles = makeStyles((theme: Theme) => ({
  tipBox: {
    display: 'flex',
    height: 70,
    flexDirection: 'row',
    outline: `1px solid ${theme.palette.grey[400]}`,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1, 3, 1, 2.5),
  },
  tipTextField: {
    marginTop: theme.spacing(0.75),
    '& .MuiInput-root input': {
      border: 'none',
      padding: 0,
      mozAppearance: 'textfield',
      '&::-webkit-outer-spin-button,::-webkit-inner-spin-button': {
        webkitAppearance: 'none',
        margin: 0,
      },
    },
    '& .MuiFormLabel-root': {
      fontSize: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightBold,
    },
  },
  icon: {
    marginRight: theme.spacing(1),
  },
  doneButton: {
    backgroundColor: 'transparent',
    color: theme.palette.primary.main,
    borderBottom: 'none',
    '&:hover': {
      borderBottom: 'none',
    },
    '& .MuiButton-label': {
      fontWeight: theme.typography.fontWeightBold,
    },
  },
  doneButtonIcon: {
    alignSelf: 'center',
    color: theme.palette.primary.main,
  },
}));

type CustomTipProps = {
  currency: Api.Currency;
  customTipAmount: string;
  isDecimal: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: () => void;
  translate: any;
};

export function CustomTip(props: CustomTipProps): JSX.Element {
  const {
    currency,
    customTipAmount,
    isDecimal,
    onChange,
    onSubmit,
    translate,
  } = props;

  const classes = useStyles();

  return (
    <div className={classes.tipBox}>
      <TextField
        className={classes.tipTextField}
        data-fd="custom-tip-input"
        InputLabelProps={{ shrink: true }}
        variant="standard"
        InputProps={{
          type: 'number',
          startAdornment: (
            <InputAdornment className={classes.icon} position="start">
              {CurrencySymbols(currency)}
            </InputAdornment>
          ),
        }}
        label={translate('Tipping_CustomTip_description')}
        onChange={onChange}
        placeholder={isDecimal ? '0.00' : '0'}
        value={customTipAmount}
      />
      <Button
        className={classes.doneButton}
        onClick={onSubmit}
        startIcon={<Tick size="s" className={classes.doneButtonIcon} />}
        variant="text"
      >
        {translate('Tipping_CustomTip_button_label')}
      </Button>
    </div>
  );
}
